import React, { useContext, useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, Redirect, useHistory } from 'react-router-dom';
import _ from 'lodash';
import ProgressFullscreen from '../components/common/ProgressFullscreen';
import { transformToDataApiFormat } from '../components/Prompt/Content/VersionCommentContent';
import { transformReviewDataToApiFormat } from 'components/Prompt/Content/GlobalReviewComment';
// import { transformRejectDataToApiFormat } from 'components/Prompt/Content/GlobalApprovalRejectComment';
import PromptContext from '../components/Prompt/PromptContext';
import {
  getLanguage,
  getMarketName,
  getConfigs,
  getAvailableLanguages
} from '../features/app/selectors';
import getApprovalSteps from '../features/PpsiContainer/approvalSteps/approvalSteps';
import useSavePpsi from '../features/PpsiContainer/hooks/useSavePpsi';
import useUtensils from '../features/UtensilContainer/hooks/useUtensils';
import PpsiForm from '../components/PpsiForm';
import usePpsi from '../features/PpsiContainer/hooks/usePpsi';
import usePpisRelatedToPpsi from '../features/PpiContainer/hooks/usePpisRelatedToPpsi';
import useGlobalPpis from '../features/PpiContainer/hooks/useGlobalPpis';
// import useGlobalPpsis from '../features/PpsiContainer/hooks/useGlobalPpsis';
import {
  ppsiPublishedRoute,
  draftPPSIsRoute,
  ppsiInProgressRoute
} from '../routes';
// import { toJS } from '../utils/immutableUtils';
import { MARKET_GLOBAL_LANG } from '../features/app/constants';

// import GlobalPpsiImport from '../features/PpsiContainer/globalPpsiImport';
import { useDiscardDraftPpsi } from '../features/PpsiContainer/hooks/usePpsiAction';
import useDiscardDraftPpsiNir from '../features/PpsiContainer/hooks/useDiscardDraftPpsiNir';

import DiscardDraftConfirmation from './DiscardDraftConfirmation';
import {
  useApprovePpsi,
  usePublishPpsi,
  useImportiFoodUpdatePpsi,
  useImportGlobalUpdatePpsi,
  useSendReviewPpsi,
  useGlobalApprovePpsi,
  useGlobalRejectPpsi,
  usePublishEmptyPpsi
} from '../features/PpsiContainer/hooks/usePpsiAction';
import { Mode } from '../components/PpsiForm/constants';
import { fetchGlobalPpsiCopy } from '../features/PpsiContainer/actions';
// import { fetchGlobalPpsis } from '../features/PpsiContainer/actions';
import useAlert from '../features/alertSystem/hooks/useAlert';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
// import {
//   SERVING_HOLDING_TEMP_UNIT_DEFAULT,
//   SERVING_HOLDING_TIME_UNIT_DEFAULT
// } from '../features/PpsiContainer/constants';
import View from './views';
import useCreateDraftPpsi from 'features/PpsiContainer/hooks/useCreateDraftPpsi';
import { States } from 'features/PpsiContainer/constants';
import useGlobalPpsi from '../features/PpsiContainer/hooks/useGlobalPpsi';
import { toJS } from 'utils/immutableUtils';
// import useGlobalPpsis from 'features/PpsiContainer/hooks/useGlobalPpsis';
import { FranchiseType } from '../constants/franchiseType';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText
} from '@material-ui/core';
import useGlobalPublishedPpiIfs from 'features/PpsiContainer/hooks/useGlobalPublishedPpiIfs';
import useApprovePpsiNir from '../features/PpsiContainer/hooks/useApprovePpsiNir';
import useMarketDishLogo from 'features/PpsiContainer/hooks/useMarketDishLogo';
//import useProductAreas from 'features/PpsiContainer/hooks/useProductAreas';
import useProductArea from 'features/DishContainer/hooks/useProductArea';
import { notify } from 'features/notificationSystem/actions';

// Hard-coded for now, could potentially be passed and query string parameter
const copyFromLanguage = MARKET_GLOBAL_LANG;

function getData(ppsi) {
  let data = _.cloneDeep(ppsi.inProgressPpsiEnrichmentData);
  const dish = data.referencedIFoodData;
  data = {
    ...data,
    ppsiId: ppsi.id,
    dish
    // servingHoldingTempUnit: SERVING_HOLDING_TEMP_UNIT_DEFAULT,
    // servingHoldingTimeUnit: SERVING_HOLDING_TIME_UNIT_DEFAULT
  };
  return data;
}

const PpsiEditView = () => {
  const [openConfirm, setOpenConfirm] = useState(false);
  const userMarket = useSelector(getMarketName);
  const franchiseType = useSelector(getConfigs).toJS().franchise;
  const { id } = useParams();
  const history = useHistory();
  const [isFetchingPpsi, ppsi, fetchPpsiError] = usePpsi(id, {
    forceFetch: true
  });
  const [isFetchingLogo, marketDishLogo, fetchError] = useMarketDishLogo({
    forceFetch: true
  });
    const [isFetchingProductArea, productArea, fetchProductAreaError] = useProductArea({
    forceFetch: true
  });
  const [isFetchingGlobalPpiIfs, getGlobalId] = useGlobalPublishedPpiIfs();

  // GET PIA ARTICLE NUMBER OF THIS DISH
  const getPiaArticleNumber = ppsi && ppsi.piaArticleNumber;
  const [discardDraftPpsi, isdiscardingDraft] = useDiscardDraftPpsi();
  const [
    onDiscardDraftPpsiNir,
    isDiscardingDraftPpsiNir
  ] = useDiscardDraftPpsiNir();

  // const [isFetchingGlobalPpis, globalPpisRaw] = useGlobalPpis();
  // const [isFetchingGlobalPpsis, globalPpsisRaw] = useGlobalPpsis();
  // const globalPpsis = toJS(globalPpsisRaw, []);
  // const globalPpis = toJS(globalPpisRaw, []);
  // console.log('getPiaArticleNumber===', getPiaArticleNumber);
  const [savePpsi, isSaving] = useSavePpsi();
  const [publishPpsi, isPublishing] = usePublishPpsi();
  const [approvePpsi, isApproving] = useApprovePpsi();
  const [publishEmptyPpsi, isPublishingEmptyPpsi] = usePublishEmptyPpsi();
  const [sendPpsiForGlobalReview, isSendingGlobalReview] = useSendReviewPpsi();
  const [approveGlobalReviewPpsi, isGlobalApproving] = useGlobalApprovePpsi();
  const [rejectGlobalReviewPpsi, isGlobalRejecting] = useGlobalRejectPpsi();
  const [isFetchingRelatedPpis] = usePpisRelatedToPpsi(id);
  const activeLanguage = useSelector(getLanguage);
  const languages = useSelector(getAvailableLanguages);
  const { open: openPrompt } = useContext(PromptContext);
  //const [piaProductAreas] = useProductAreas();
  const [
    importiFoodUpdatePpsi,
    isUpdatingiFoodPpsi
  ] = useImportiFoodUpdatePpsi();

  const [
    importGlobalUpdatePpsi,
    getIsImportingGlobalUpdate,
    getimportingGlobalUpdateError
  ] = useImportGlobalUpdatePpsi();

  const [
    createDraftPpsi,
    isCreatingDraft,
    isCreateDraftDone
  ] = useCreateDraftPpsi();

  const [approvePpsiNir] = useApprovePpsiNir();

  // const [isFetchingPpsis, globalPpsisRaw] = useGlobalPpsis();
  const [openAlert, closeAlert] = useAlert();
  const [showWarn, setShowWarn] = useState(false);

  // IMPORT AND MERGE GLOBAL UPDATE DATA
  // function getGlobalImportData(ppsi, dishes, formData) {
  //   const dish = dishes.inProgressPpsiEnrichmentData.referencedIFoodData;
  //   let data = {
  //     ...ppsi,
  //     ppsiId: formData.ppsiId,
  //     dish: dish
  //   };
  //   return data;
  // }

  // GET ALL GLOBAL PPSIS TO IMPORT DATA FROM
  // const globalPpsis = toJS(globalPpsisRaw, []);

  // FILTER ONLY PUBLISHEDD GLOBAL PPSIS
  // const publishedGlobalPpsis =
  //   globalPpsis && globalPpsis.filter(i => i.status === 'PUBLISHED');

  // FILTER GLOBAL PPSIS WITH PIA ARTICLE NUMBER
  // const getGlobalPpsistoImport =
  //   publishedGlobalPpsis &&
  //   publishedGlobalPpsis.filter(
  //     i => i.piaArticleNumber === getPiaArticleNumber
  //   );

  // REMOVE MULTIPLE GLOBAL INSTRUCTION WITH SINGLE PIA ARTICLE NUMBER
  // const finalGlobalPpsistoImport = getGlobalPpsistoImport[0];

  // const {data} = useContext(FormContext);

  let parentPpsiEnrichmentDataId = null;
  if (ppsi) {
    if (
      ppsi.inProgressPpsiEnrichmentData &&
      ppsi.inProgressPpsiEnrichmentData.parentPpsiId !== null
    ) {
      parentPpsiEnrichmentDataId =
        ppsi.inProgressPpsiEnrichmentData.parentPpsiId;
    }
  }
  const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(fetchGlobalPpsiCopy(parentPpsiEnrichmentDataId));
  //   getGlobalId(parentPpsiEnrichmentDataId)
  // }, [parentPpsiEnrichmentDataId]);

  const prevParentPpsiIdRef = useRef(null);
  useEffect(() => {
    if (ppsi && ppsi.inProgressPpsiEnrichmentData) {
      // console.log(ppsi.publishedPpsiEnrichmentData, 'first if');
      const newParentPpsiId = ppsi.inProgressPpsiEnrichmentData.parentPpsiId;
      if (newParentPpsiId && newParentPpsiId !== prevParentPpsiIdRef.current) {
        // console.log(ppsi.publishedPpsiEnrichmentData, 'second if');
        // setGlobalPPsiId(newParentPpsiId);
        dispatch(fetchGlobalPpsiCopy(newParentPpsiId));
        prevParentPpsiIdRef.current = newParentPpsiId;
        getGlobalId(newParentPpsiId);
      }
    }
  }, [dispatch, ppsi]);

  // isFetchingPpsi = useSelector(getIsFetching)

  const isFetching =
    isFetchingPpsi ||
    isFetchingRelatedPpis ||
    isCreatingDraft ||
    isFetchingGlobalPpiIfs ||
    isFetchingLogo;

  const [fromPpsiId, setFromPpsiId] = useState(null);

  useEffect(() => {
    if (ppsi && ppsi.inProgressPpsiEnrichmentData) {
      // console.log(ppsi,"ppsi.parentPpsiId")
      setFromPpsiId(ppsi.inProgressPpsiEnrichmentData.parentPpsiId);
    }
  }, [ppsi]);

  // Call useGlobalPpsi hook unconditionally
  const [fromPpsiRaw] = useGlobalPpsi(fromPpsiId, {
    forceFetch: !!fromPpsiId
  });
  // console.log(fromPpsiRaw,"fromPpsiRawfromPpsiRaw")
  const fromPpsi = toJS(fromPpsiRaw);
  // Initiate fetch of utensils
  // const [isFetchingDishes, dishes] = useDishes({formulaCode:"PRF12125492"});
  // useEffect(() => {
  //   console.log(fromPpsi, 'fromPpsifromPpsi');
  // }, [fromPpsi]);
  useUtensils();
  // useGlobalPpis();

  function handlePublishEmptyPpsi() {
    const iFoodDiscontinuedItems =
    ppsi.inProgressPpsiEnrichmentData !== undefined &&
    ppsi.inProgressPpsiEnrichmentData.updateNotificationList !== undefined &&
    ppsi.inProgressPpsiEnrichmentData.updateNotificationList.length > 0 &&
    ppsi.inProgressPpsiEnrichmentData.updateNotificationList.filter(i => i.category === 'IFOOD_UPDATE');

  const iFoodDiscontinued =
    iFoodDiscontinuedItems.length > 0 &&
    iFoodDiscontinuedItems.map(i => i.message);

  const handleEmptyPublishedPpsi =
    iFoodDiscontinued.length > 0 &&
    iFoodDiscontinued.includes(
      'This dish is no longer available. This dish is Discontinued'
    );
    if(handleEmptyPublishedPpsi){
      dispatch(
              notify({
                message:
                  'Failed to Publish Dish instruction. Reason: Dish is discontinued in iFood!',
                variant: 'error'
              })
            );
    }else{
       publishEmptyPpsi(id);
    }
   
  }

  function handleApprove(ppsiData) {
    const steps = getApprovalSteps(ppsiData);

    const approve = approvalData => {
      const { ppsiId } = ppsiData;
      let body;
      if (approvalData) {
        body = {
          versionComments: approvalData,
          isUpdateSelected: approvalData.isUpdateSelected
        };
        delete body.versionComments.isUpdateSelected;
      } else {
        body = approvalData;
      }
      if (franchiseType !== FranchiseType.INGKA) {
        approvePpsiNir(ppsiId, body);
      } else {
        approvePpsi(ppsiId, body);
      }
    };
    const onDone = ({ promptState }) => {
      const approvalData = transformToDataApiFormat(promptState);
      approve(approvalData);
    };

    checkSteps(steps, ppsiData, onDone, approve);
  }

  function handleSubmitForReview(ppsiData) {
    const steps = getApprovalSteps(ppsiData);

    const approve = approvalData => {
      const { ppsiId } = ppsiData;
      sendPpsiForGlobalReview(ppsiId, approvalData);
    };
    const onDone = ({ promptState }) => {
      const approvalData = transformToDataApiFormat(promptState);
      const reviewComment = transformReviewDataToApiFormat(promptState);
      const submitData = { versionComments: approvalData, ...reviewComment };
      approve(submitData);
    };
    checkSteps(steps, ppsiData, onDone, approve);
  }

  function checkSteps(steps, ppsiData, onDone, callBack) {
    if (languages.size > 1 && ppsiData.status !== 'GLOBAL APPROVED') {
      openAlert({
        title: (
          <FormattedMessage id="notify.PpsiMultipleLanguageAlertMessage" />
        ),
        content: (
          <FormattedMessage id="notify.PpsiMultipleLanguageAlertMessageDesc" />
        ),
        actions: {
          right: [
            <Button
              key="saveAndLeave"
              onClick={() => {
                closeAlert();
              }}
              color="primary"
            >
              <FormattedMessage id="notify.PpsiMultipleLanguageAlertCancel" />
            </Button>,
            <Button
              key="stay"
              onClick={() => {
                closeAlert();
                if (steps.length > 0) {
                  openPrompt({ steps, data: ppsiData, onDone });
                } else {
                  callBack();
                }
              }}
              color="primary"
            >
              <FormattedMessage id="notify.PpsiMultipleLanguageAlertSuccess" />
            </Button>
          ]
        }
      });
    } else if (steps.length > 0) {
      openPrompt({ steps, data: ppsiData, onDone });
    } else {
      callBack();
    }
  }

  function handleSave(data, callback) {
    let nData = data;
    if (Object.keys(nData).includes('referencedIFoodData')) {
      nData = {
        ...data,
        referencedIFoodData: {
          ...data.referencedIFoodData,
          referencedIngredientEntities: data.referencedIFoodData.referencedIngredientEntities
            .sort((a, b) => a.lineId - b.lineId)
            .map((itm, i) => ({ ...itm, lineId: i + 1 }))
        }
      };
    } else {
      nData = data;
    }
    savePpsi(nData, callback);
  }

  function handlePublish(formData) {
    publishPpsi(formData.ppsiId);
  }

  function handleiFoodUpdatePpsi(formData) {
    importiFoodUpdatePpsi(formData.ppsiId);
  }

  if (fetchPpsiError) {
    throw fetchPpsiError;
  }

  if (isFetching) {
    return <ProgressFullscreen open />;
  }

  if (!ppsi) {
    return <Redirect to={draftPPSIsRoute()} />;
  }

  // PPSI has published / approved directly to published
  if (!ppsi.inProgressPpsiEnrichmentData && ppsi.publishedPpsiEnrichmentData) {
    return <Redirect to={ppsiPublishedRoute(id)} />;
  }

  View.PpsiEdit.visit(ppsi, activeLanguage);

  // Get the local market presentation name and append to Global import data
  // function getLocalPresentationName(data, ppsi) {
  //   const localPresentationName =
  //     ppsi.inProgressPpsiEnrichmentData.info[activeLanguage].presentationName;
  //   const dataWithoutName = _.cloneDeep(data);
  //   dataWithoutName.info[
  //     activeLanguage
  //   ].presentationName = localPresentationName;
  //   return dataWithoutName;
  // }

  function handleGlobalUpdatePpsi() {
    importGlobalUpdatePpsi(id);
    // if (finalGlobalPpsistoImport === undefined) {
    //   return console.log('No Global PPSI Published EnrichmentData');
    // } else {
    //   let importGlobalData = GlobalPpsiImport(
    //     finalGlobalPpsistoImport,
    //     finalGlobalPpsistoImport.publishedPpsiEnrichmentData.id,
    //     copyFromLanguage,
    //     languages
    //   );

    //   let finalData = getLocalPresentationName(importGlobalData, ppsi);
    //   const results = getGlobalImportData(finalData, ppsi, formData);
    //   savePpsi(results, callback);
    // }
  }

  const typePpsi = ppsi && ppsi.hasOwnProperty('ppsiVersion');

  function handleDiscardDraft() {
    if (franchiseType !== FranchiseType.INGKA) {
      onDiscardDraftPpsiNir(id, [ppsi.formulaCode]);
    } else {
      discardDraftPpsi(id);
    }
  }

  function handleEditInstruction() {
    const hasInProgress = ppsi.inProgressPpsiEnrichmentData;
    if (
      hasInProgress.status === States.SCHEDULED ||
      hasInProgress.status === States.GLOBALREVIEW
    ) {
      createDraftPpsi(id, hasInProgress.status);
    }
  }

  function handleEditInstruction() {
    if (
      ppsi.inProgressPpsiEnrichmentData.status === States.GLOBALREVIEW ||
      ppsi.inProgressPpsiEnrichmentData.status === States.SCHEDULED
    ) {
      createDraftPpsi(id, ppsi.inProgressPpsiEnrichmentData.status);
      history.push(ppsiInProgressRoute(id));
    }
  }

  return (
    <>
      <PpsiForm
        data={getData(ppsi)}
        showProgress={
          isSaving ||
          isPublishing ||
          isApproving ||
          getIsImportingGlobalUpdate ||
          isPublishingEmptyPpsi
        }
        dataLabels={{
          title: (data, { language }) => data.info[language].presentationName,
          status: () => ppsi.inProgressPpsiEnrichmentData.status,
          modifiedBy: 'lastModifiedBy',
          modifiedDate: 'modifyDate'
        }}
        mode={Mode.EDIT}
        onSave={handleSave}
        onApprove={handleApprove}
        onSubmitForReview={handleSubmitForReview}
        onPublish={handlePublish}
        onPublishEmptyPpsi={handlePublishEmptyPpsi}
        oniFoodUpdatePpsi={handleiFoodUpdatePpsi}
        onGlobalUpdatePpsi={handleGlobalUpdatePpsi}
        setOpenConfirm={setOpenConfirm}
        completePpsiData={ppsi}
        globalData={fromPpsi}
        // globalPpsis={globalPpsis}
        // globalPpis={globalPpis}
        onCreateDraft={() => {
          if (ppsi.inProgressPpsiEnrichmentData.status === States.SCHEDULED) {
            handleEditInstruction();
          } else {
            setShowWarn(true);
          }
        }}
      />
      {openConfirm && (
        <DiscardDraftConfirmation
          open={openConfirm}
          setOpen={setOpenConfirm}
          handleDiscardDraft={handleDiscardDraft}
          typePpsi={typePpsi}
          data={getData(ppsi)}
        />
      )}
      <Dialog open={showWarn}>
        <DialogContent>
          <DialogContentText component="div">
            This action will cancel your request for Global Approval
          </DialogContentText>
        </DialogContent>
        <>
          <DialogActions>
            <Button
              key="stay"
              onClick={() => setShowWarn(false)}
              color="primary"
              style={{ marginRight: '55px' }}
            >
              WAIT I'VE CHANGED MY MIND
            </Button>
            <Button
              key="leave"
              onClick={() => {
                setShowWarn(false);
                handleEditInstruction();
              }}
              color="primary"
            >
              I'M OK WITH THAT
            </Button>
          </DialogActions>
        </>
      </Dialog>
    </>
  );
};

export default PpsiEditView;
